import { render, staticRenderFns } from "./fieldPillButton.vue?vue&type=template&id=35a29ec6&"
import script from "./fieldPillButton.vue?vue&type=script&lang=js&"
export * from "./fieldPillButton.vue?vue&type=script&lang=js&"
import style0 from "./fieldPillButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports